import { Navigate } from "react-router-dom";
import ImmobiliareContent from "../components/ImmobiliareContent";
import ImmobiliPortalChangePasswordDialog from "../components/ImmobiliPortalChangePasswordDialog";
import { useImmobiliPortalAuth } from "../context/ImmobiliPortalAuthContext";

export default function ImmobiliPortal() {
  const { token, user, loading, logout, mustChangePassword } = useImmobiliPortalAuth();

  if (!token && !loading) {
    return <Navigate to="/portale-immobiliare/login" replace />;
  }

  if (loading && !mustChangePassword) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-[#F4F6FA]">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-11 w-11 border-[3px] border-blue-200 border-t-[#4068E8]" />
          <p className="text-sm text-slate-500 font-medium">Caricamento...</p>
        </div>
      </div>
    );
  }

  const displayName = [user?.nome, user?.cognome].filter(Boolean).join(" ") || user?.email;

  return (
    <>
      <ImmobiliPortalChangePasswordDialog open={mustChangePassword} />
      <div className={mustChangePassword ? "pointer-events-none select-none blur-sm" : undefined}>
        <ImmobiliareContent
          token={token}
          userInfo={{ name: displayName, email: user?.email }}
          portalMode
          showHeader={false}
          onLogout={logout}
          contentEnabled={!mustChangePassword}
        />
      </div>
    </>
  );
}
